import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import * as reducers from "./reducers";
import App from "./components/app";
import registerServiceWorker from "./registerServiceWorker";

const createStoreWithMiddleware = applyMiddleware(
  thunk,
  ...(process.env.NODE_ENV !== "development"
    ? []
    : [
        createLogger({
          duration: true,
        }),
      ])
)(createStore);
const reducer = combineReducers({
  ...reducers,
});
const store = createStoreWithMiddleware(reducer);

ReactDOM.render(
  <Provider store={store}>
    <Router basename="/sales/hc_demo">
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();
